module.exports = __webpack_public_path__ + "static/media/plaid.6e5f3880.svg";